import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface SetPositionWishToCandidateResponse extends BackendResponse {}
export interface SetPositionWishToCandidateParameters extends NextApiParams {
  items: SetPositionWishToCandidateParameterItem[];
}

export interface SetPositionWishToCandidateParameterItem {
  positionType: number;
  level: number;
}

export const setPositionWishToCandidate = withNextApi<
  SetPositionWishToCandidateResponse,
  SetPositionWishToCandidateParameters
>("/cvp/CvpSetPositionWishToCandidate");
